import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import { Draggable } from 'react-beautiful-dnd';
import Colors from '../../../../styles/colors';
import { canUserAccessFeature } from '../../../../helpers/userinfoHelper';
import ReimportEpisodes from '../../../../components/support/ReimportEpisodes';
import { getLandingPageUrl } from '../../../../helpers/soundcasts';
import Subscribers from './Subscribers';
import {
  SoundcastRow,
  SoundcastDrag,
  SoundcastInfo,
  SoundcastImage,
  SoundcastDescription,
  SoundcastUpdated,
  SoundcastLinksRow,
  SoundcastLinks,
  SoundcastStatus,
  SoundcastSubscribers,
  SoundcastActionButton,
  SoundcastDropdownMenu,
} from './styled';
const { polishImageUrl } = require('../../../../../server/scripts/utils.js')();

const getDraggableItemStyle = (isDragging, draggableStyle) => ({
  // background: isDragging ? "lightgreen" : "grey",
  ...draggableStyle,
});

export default class SoundcastDraggable extends Component {
  render() {
    const {
      soundcast,
      publisher,
      index,
      isMonitoringAccount,
      onNonPaymentSignup,
      onCheckout,
      onTracks,
      onAnalytics,
      onEdit,
      onDelete,
      onReplicate,
    } = this.props;
    const {
      landingPage,
      prices,
      disableSignup = false,
      last_update = false,
      lastEpisodeUpdate = false,
    } = soundcast;
    const soundcastLastUpdate = Number(lastEpisodeUpdate || last_update);
    const isPrivate = soundcast.published && !soundcast.landingPage;
    const canAccessNonPaymentPage = canUserAccessFeature('NON_PAYMENT_ACCESS_LINK');

    const preStatusTxt = soundcast.published ? 'Published' : 'Draft';
    const chargeState = soundcast.forSale ? 'For Sale' : 'Free';
    const preStateTxt = isPrivate ? 'Private' : chargeState;
    const soundcastStatus = soundcast.published ? [preStatusTxt, preStateTxt] : [preStatusTxt];

    const { youtubeConnect = {}, soundcastFromYoutube = {} } = publisher;
    const youtubeState = youtubeConnect[soundcast.id] || '';
    const youtubeProps = soundcastFromYoutube[soundcast.id] || {};
    let youtubeLink = '';
    let youtubeTitle = '';
    if (!isEmpty(youtubeProps)) {
      if (!isEmpty(youtubeProps.playlistId)) {
        youtubeLink = `https://www.youtube.com/playlist?list=${youtubeProps.playlistId}`;
        youtubeTitle = `view youtube play list "${youtubeProps.playlistName}"`
      } else if (!isEmpty(youtubeProps.channelId)) {
        youtubeLink = `https://www.youtube.com/channel/${youtubeProps.channelId}`;
        youtubeTitle = `view youtube channel "${youtubeProps.channelName}"`
      }
    }

    return (
      <Draggable
        key={`soundcast-${soundcast.id}`}
        draggableId={`soundcast-${soundcast.id}`}
        index={index}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={getDraggableItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
            <SoundcastRow className="row" key={index}>
              <SoundcastDrag className=" col-md-1 col-sm-1 col-xs-1">
                <i className="material-icons">drag_handle</i>
              </SoundcastDrag>
              <SoundcastInfo className=" col-md-6 col-sm-11 col-xs-11">
                <div className="row">
                  <div className="col-md-2 col-sm-2 col-xs-2">
                    <SoundcastImage src={polishImageUrl(soundcast.imageURL)} alt="image" />
                  </div>
                  <SoundcastDescription className="col-md-7 col-sm-6 col-xs-10">
                    <span>{soundcast.title}</span>
                    {soundcastLastUpdate && (
                      <React.Fragment>
                        <SoundcastUpdated>
                          Last updated: {moment.unix(soundcastLastUpdate).format('MMM DD YYYY')}
                        </SoundcastUpdated>
                        <SoundcastStatus published={soundcast.published}>
                          {soundcastStatus.join(', ')}
                        </SoundcastStatus>
                      </React.Fragment>
                    )}
                    {isMonitoringAccount && <ReimportEpisodes soundcast={soundcast} />}
                  </SoundcastDescription>
                  <SoundcastSubscribers className="col-md-3 col-sm-4 col-xs-12">
                    <Subscribers soundcast={soundcast} />
                  </SoundcastSubscribers>
                </div>
                <SoundcastLinksRow className="row">
                  <div className="col-md-12">
                    <SoundcastLinks disableSignup={disableSignup} youtubeState={youtubeState}>
                      {landingPage && (
                        <a
                          className="landing-page-link"
                          target="_blank"
                          href={getLandingPageUrl(soundcast.id, soundcast.published)}>
                          <span
                            datatoggle="tooltip"
                            dataplacement="top"
                            title="view soundcast landing page">
                            <strong>Landing page</strong>
                          </span>
                        </a>
                      )}
                      {(landingPage || isPrivate) && canAccessNonPaymentPage && (
                        <a
                          className="non-payment-signup-link"
                          target="_blank"
                          onClick={onNonPaymentSignup}>
                          <span
                            datatoggle="tooltip"
                            dataplacement="top"
                            title="view soundcast signup form">
                            <strong>Non-payment signup</strong>
                          </span>
                        </a>
                      )}
                      {landingPage && prices && prices[0].price > 0 && (
                        <a className="checkout-page-link" target="_blank" onClick={onCheckout}>
                          <span
                            datatoggle="tooltip"
                            dataplacement="top"
                            title="view soundcast checkout form">
                            <strong>Checkout page</strong>
                          </span>
                        </a>
                      )}
                      {!isEmpty(youtubeState) && (
                        <a
                          className="youtybe-link"
                          target="_blank"
                          href={youtubeLink}>
                          <span
                            datatoggle="tooltip"
                            dataplacement="top"
                            title={youtubeTitle}>
                            <strong>YouTube&nbsp;{youtubeState}</strong>
                          </span>
                        </a>
                      )}
                    </SoundcastLinks>
                  </div>
                </SoundcastLinksRow>
              </SoundcastInfo>
              <SoundcastInfo className="col-md-5 col-sm-12 col-xs-12">
                <SoundcastActionButton
                  className="col-md-4 col-sm-4 col-xs-12"
                  datatoggle="tooltip"
                  dataplacement="top"
                  title="existing tracks"
                  onClick={onTracks}>
                  <span>Tracks</span>
                </SoundcastActionButton>
                <SoundcastActionButton
                  color={Colors.mainOrange}
                  className="col-md-4 col-sm-4 col-xs-12"
                  datatoggle="tooltip"
                  dataplacement="top"
                  title="show soundcast analytics"
                  onClick={onAnalytics}>
                  <span>Analytics</span>
                </SoundcastActionButton>
                <SoundcastDropdownMenu className="col-md-2 col-sm-2 col-xs-2">
                  <div className="dropdown pull-right">
                    <div
                      id="multi-action-dropdown"
                      className="btn dropdown-toggle"
                      data-toggle="dropdown">
                      <i className="fas fa-ellipsis-v" />
                    </div>
                    <ul className="dropdown-menu alt-font">
                      <li>
                        <a
                          datatoggle="tooltip"
                          dataplacement="top"
                          title="edit soundcast"
                          onClick={onEdit}>
                          Edit
                        </a>
                      </li>
                      <li>
                        <a
                          datatoggle="tooltip"
                          dataplacement="top"
                          title="delete soundcast"
                          onClick={onDelete}>
                          Delete
                        </a>
                      </li>
                      <li>
                        <a
                          datatoggle="tooltip"
                          dataplacement="top"
                          title="replicate soundcast"
                          onClick={onReplicate}>
                          Replicate
                        </a>
                      </li>
                    </ul>
                  </div>
                </SoundcastDropdownMenu>
              </SoundcastInfo>
            </SoundcastRow>
          </div>
        )}
      </Draggable>
    );
  }
}

SoundcastDraggable.propTypes = {
  index: PropTypes.number,
  soundcast: PropTypes.object,
  publisher: PropTypes.object,
  isMonitoringAccount: PropTypes.bool,
  onNonPaymentSignup: PropTypes.func,
  onCheckout: PropTypes.func,
  onTracks: PropTypes.func,
  onAnalytics: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onReplicate: PropTypes.func,
};

SoundcastDraggable.defaultProps = {
  index: 0,
  soundcast: null,
  publisher: {},
  isMonitoringAccount: false,
  onNonPaymentSignup: () => {},
  onCheckout: () => {},
  onTracks: () => {},
  onAnalytics: () => {},
  onEdit: () => {},
  onDelete: () => {},
  onReplicate: () => {},
};
